import React from 'react';
import Datetime from './Datetime.jsx';

export default function (props) {
  return <Datetime format="dd/MM/yyyy" locale="fr-FR" {...props}/>;
}